module.exports = __webpack_public_path__ + "img/panda.32e0324d.svg";